import { createClient } from '@sanity/client';

const client = createClient({
    projectId: 'lwidwtmt',
    dataset: 'production',
    useCdn: true,
    apiVersion: "2023-07-30"
});

export default client
